import { Splide, SplideSlide } from "@splidejs/react-splide";

import banner01 from "../../assets/images/myanwan/banner-01.png";
import banner02 from "../../assets/images/myanwan/banner-01.png";

const Banner = () => {
  const images = [banner01, banner02];
  return (
    <div className="">
      <Splide
        options={{
          rewind: true, // If you want the slider to go back to the first slide after the last slide.

          arrows: false, // Hides the navigation arrows.
          autoplay: true, // Enables autoplay mode.
          interval: 3000, // Interval between each slide transition (in milliseconds).
          loop: true, // Enables infinite looping.
          type: "loop", // Sets the slider type to loop mode for continuous rotation
          direction: "ltr",
          pauseOnHover: false, // Optional: Prevents autoplay from pausing when hovering.
          pauseOnFocus: false, // Optional: Prevents autoplay from pausing when the slider gains focus.
        }}
      >
        {images.map((banner, i) => {
          return (
            <SplideSlide className={"aspect-video md:[aspect-ratio:16/7]"}>
              <img
                src={banner}
                alt={`banner ${i + 1} image`}
                className="w-full h-full object-cover"
              />
            </SplideSlide>
          );
        })}
      </Splide>
    </div>
  );
};
export default Banner;
